import React, { useEffect, useState } from 'react'
import CancellationForm, {
  CancellationFormDataType,
} from '../components/forms/CancellationForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import {
  CaseCARespType,
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type CancellationPageProps = {
  transitions: CancellationPageTransitions
}

export type CancellationPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const CancellationPage = (props: CancellationPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      //history.push(pathToCancellationExpenses)
      props.transitions.goToNextPage()
    },
  })

  const { fetch: fetchData, pending: loading } = useGetData({})

  React.useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [ifEqual])

  const handleBackButtonPage = () => {
    //history.push(pathToClaimant)
    props.transitions.goBack()
  }

  const currentCancellationData = {
    caseCommon: state.loadedCaseReportResp?.caseCommon,
    caseCA: state.loadedCaseReportResp?.caseCA,
  }

  const handleCancellationPageSubmitted = (
    cancellationFormData: CancellationFormDataType
  ) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state

    // DEFINOVAT TYP
    const caseCARefresh: CaseCARespType = {
      ...cancellationFormData.caseCA,
      priceCur: loadedCaseReportResp?.caseCA?.priceCur,
      refundCur: loadedCaseReportResp?.caseCA?.refundCur,
      currency: loadedCaseReportResp?.caseCA?.currency,
      attachmentList: [],
    }
    /* 
        // CR: nelze to lépe zapsat takto?
        // v čem je rozdíl oproti předchozímu zápisu?
        const caseCARefresh2: CaseCARespType = {
          ...loadedCaseReportResp?.caseCA, // existující data caseCA
          ...cancellationFormData.caseCA, // a existující data přepíšu pořízenými daty z formuláře
          // ??? attachmentList: [], // v samostatném kroku
        }
     */
    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      caseCA: caseCARefresh,
      caseCommon: cancellationFormData.caseCommon,
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    a zmenime 'stranku'
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 3 },
    })

    // 4. data posilame na server funkcí, která odesílá data na server a obsluhuje (loading+error)
    //    A) nejdrive to napiseme v teto komponente -- do funkce
    //    B) POZDEJI -- V JINEM KROKU -- pak zrefaktorujeme do jednotneho hook (jako useGetData)
    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }
  //console.log(state.loadedCaseReportResp, 'state')
  return (
    <CancellationForm
      caseReportId={state.caseReportId!}
      cancellationData={currentCancellationData}
      onPageContinue={handleCancellationPageSubmitted}
      onPageBack={handleBackButtonPage}
      errorMessage={state.error}
      isContinueInProgress={pending}
      isDataLoading={loading}
      setIfEqual={setIfEqual}
    />
  )
}

export default CancellationPage
